import script from "./SegmentsPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentsPicker.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentsPicker.vue?vue&type=style&index=0&id=4b252017&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b252017"]])

export default __exports__